module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#google-g",
      toString: function () {
        return this.url;
      }
    }